<template>
    <div>
        <vue-headful title="Credimóvil | Formulario"/>
        <div>
            <!-- Header Area -->
            <header class="main_header_area mha_2">
                <div class="container">
                    <div class="header_menu">
                        <nav class="navbar navbar-expand-lg">
                            <!-- Small Divice Menu-->
                            <div class="navbar-toggler bg-menu col-12 m-0 p-0" data-toggle="collapse" data-target=".navbar_supported" aria-expanded="false" aria-label="Toggle navigation">
                                <v-step-progress
                                    :steps="['', '']"
                                    passive-color="#B9E4E0"
                                    active-color="#f59019"
                                    :current-step="userData.data.a_step  - 6"
                                    icon-class="fa fa-1x fa-check-circle"
                                    >
                                </v-step-progress>
                            </div>
                            <div class="collapse navbar-collapse navbar_supported m-0 p-0 bg-menu" >
                                <div class="col-12 " >
                                    <v-step-progress
                                    :steps="['',  '']"
                                    passive-color="#B9E4E0"
                                    active-color="#f59019"
                                    :current-step="userData.data.a_step  - 6"
                                    icon-class="fa fa-4x fa-check-circle"
                                    ></v-step-progress>
                                </div>
                                <!--<li class="apply_right" v-if="useApplyNow !== false"><a class="theme_btn" style="cursor: pointer" href="/pre-approval">Solicita tu crédito</a></li>-->
                            </div>
                        </nav>
                    </div>
                </div>
            </header>
            <!-- Header Area -->
        </div>
        <!-- Banner Area -->
        <section class="banner_area banner_area_5">

        </section>
        <!-- Banner Area -->

        <!-- Easy cash Area -->
        <section class="easy_cash_area cot-credict">
            <transition
                enter-active-class="animate__animated animate__fadeIn"
                leave-active-class="animate__animated animate__fadeOut"
                mode="out-in"
                tag="div">
                <v-about-you
                v-if="userData.data.a_step  === 6"
                    @next="saveStepUser(userData.data.a_step + 1);"
                    @previous="saveStepUser(userData.data.a_step - 1);"
                    key="1">
                </v-about-you>
               <!-- <v-economic-data
                    v-if="userData.data.a_step  === 7"
                    @next="saveStepUser(userData.data.a_step + 1);"
                    @previous="saveStepUser(userData.data.a_step - 1)"
                    key="2">
                </v-economic-data>-->
                <v-reference
                    v-if="userData.data.a_step  === 7"
                    @next="saveStepUser(userData.data.a_step + 1);"
                    @previous="saveStepUser(userData.data.a_step - 1)"
                    key="2">
                </v-reference>
            </transition>
        </section>
    </div>

</template>

<script>
    import AboutYou from "./aboutYou";
    /*import EconomicData from*/ "./EconomicData";
    import Reference from "./Reference";
    import "vue-step-progress/dist/main.css";
    import StepProgress from "vue-step-progress";

    export default {
        name: "App",
        components: {
        "v-step-progress": StepProgress,
        "v-about-you": AboutYou,
       /* "v-economic-data": EconomicData,*/
        "v-reference": Reference,
        },
        computed: {
            isLoading() {
                return this.isLoadingSupportedCompanies;
            },
        },
        data() {
            return {
                isLoadingSupportedCompanies: false,
                supportedCompanies: [],
                userData: {
                    data: {
                        a_step: 6,
                    }
                }
            };
        },
        methods: {
            getUser() {
                this.$UserService.getUser().then((result) => {
                    if (result.data.length > 0) {
                        this.userData.data.a_step = Number(result.data[0].a_step) == 10? 6: Number(result.data[0].a_step);
                    }
                }, (err) => {this.$swal("CUIDADO!",err.msg,'error');this.preloaderHiden();});
            },
            saveStepUser(newStep){
                this.userData.data.a_step = newStep;
                this.$UserService.updateUser(this.userData)
                .then((result) => {
                }, (err) => {this.$swal("CUIDADO!",err.msg,'error');this.preloaderHiden();});
            }

        },
        created() {
            this.getUser();
            //this.init();       /* Error [Vue warn]: Error in created hook: "TypeError: this.init is not a function" */
            //window.scrollTo(0, 0);
        },
    };
</script>

  <style lang="scss">
    .error {
      border-color: red !important;
      background: #FDD;
    }

    .error:focus {
      outline-color: #F99;
    }

    .nice-select .current {
        width: -webkit-fill-available !important;
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .step-progress__bar {
        align-items: center;
        display: flex;
        height: 100px;
        justify-content: space-between;
        margin-bottom: 0px !important;
        width: 100%;
    }
    .bg-menu{
        background: #55988D !important;
        box-shadow: 5px 5px 40px;   /* Sombra con un desenfoque casi disipado */
    }
    @media (max-width: 600px) {
        .step-progress__bar {
            height: 50px;
        }
        .bg-menu{
            background: transparent !important;
            box-shadow: 0px 0px 0px;   /* Sombra con un desenfoque casi disipado */
        }
        .header_menu{
            box-shadow: 10px 10px 20px;
        }
    }
  </style>



// WEBPACK FOOTER //
// src/views/GrayZone/GrayZone.vue